import ContentLoader from 'components/content/ContentLoader';
import { isNumber } from 'remeda';

import styles from './styles/SidebarSection.module.scss';

interface SidebarSectionSkeletonProps {
    header: string;
    count?: number;
}

const SidebarSectionSkeleton = ({ header, count }: SidebarSectionSkeletonProps) => {
    const defaultSkeleton = (
        <>
            <li className={styles.SidebarSection__item}>
                <ContentLoader height='16px' width='20%' />
            </li>
            <li className={styles.SidebarSection__item}>
                <ContentLoader height='16px' width='20%' />
            </li>
            <li className={styles.SidebarSection__item}>
                <ContentLoader height='16px' width='20%' />
            </li>
        </>
    );

    const hasValidCount = isNumber(count) && count > 0;

    return (
        <div className={styles.SidebarSection} data-testid={`sidebar-section-skeleton-${header}`}>
            <p className={styles.SidebarSection__title} data-testid={`sidebar-section-skeleton-${header}-title`}>
                {header}
            </p>
            <ul className={styles.SidebarSection__list}>
                {hasValidCount
                    ? Array.from({ length: count }).map((_, idx) => (
                          <li
                              className={styles.SidebarSection__item}
                              data-testid={`sidebar-section-skeleton-${header}-line`}
                              key={`sidebar-section-skeleton-line-${header}-${idx}`}
                          >
                              <ContentLoader height='16px' width='20%' />
                          </li>
                      ))
                    : defaultSkeleton}
            </ul>
        </div>
    );
};

export default SidebarSectionSkeleton;
